"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Toast = require("react-semantic-toasts");
var react_router_dom_1 = require("react-router-dom");
var Home_1 = require("./components/Home");
var AuthHome_1 = require("./components/AuthHome");
var NavMenu_1 = require("./components/NavMenu");
var Application_1 = require("./components/Application");
var ScrollToTop_1 = require("./components/ScrollToTop");
var Auth_1 = require("./stores/Auth");
var ReactGA = require("react-ga");
var createBrowserHistory = require("history");
require("react-semantic-toasts/styles/react-semantic-alert.css");
require("react-datepicker/dist/react-datepicker.css");
// Get the currently logged in user
var user = Auth_1.default.getUser();
var history = createBrowserHistory.createBrowserHistory();
var trackingId = 'UA-9077260-9'
ReactGA.initialize(trackingId);
history.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
})
var App = function () {
    return (React.createElement(react_router_dom_1.Router, { history: history },
    React.createElement(ScrollToTop_1.ScrollToTop, null),
    React.createElement(Toast.SemanticToastContainer, { position: 'top-center' }),
    React.createElement(NavMenu_1.default, { key: 'NavMenu' },
        React.createElement(react_router_dom_1.Switch, { key: 'Switch' },
            React.createElement(react_router_dom_1.Route, { key: 'Home', exact: true, path: '/', render: function () { return user ? React.createElement(AuthHome_1.default, { authUser: user }) : React.createElement(Home_1.default, null); } }),
            React.createElement(react_router_dom_1.Route, { key: 'Application', path: '/application/:id?', component: Application_1.default }))))); };
exports.default = App;
//# sourceMappingURL=App.js.map